export enum RouteEnum {
    profile = "ProfileUser",
    profileDashboard = "profile_dashboard",
    stockDetail = "stockDetails",
}

export const RouteServiceInjector = "routingService";